interface KinshipCategoryFlowParams {
    isKinshipTest: boolean;
    participantCount: number;
    participantsMin: number | null;
}

export function isKinshipCategoryFlowEnabled({
    isKinshipTest,
    participantCount,
    participantsMin,
}: KinshipCategoryFlowParams): boolean {
    const minimumParticipants = Math.max(participantsMin ?? 1, 2);

    return isKinshipTest
        && participantCount === 2
        && participantCount >= minimumParticipants;
}
